import { APP_EVENTS } from "@Core";
import { Bus, OnReadyEvent } from "@Modules/event_module";
import { OptionsModule } from "@Modules/options_module";
import { UIModule } from "@Modules/ui_module";
import { UIOptions, UIUserProfileOptions, UserProfileNavBar } from "@Modules/ui_module/_models";
import { TemplateRenderer } from "@Modules/ui_module/_templating/template.renderer";
import { Logger, LoggerService } from "@Shared/logger";

import { EventUtil, UIUtil } from "@Shared/utils";

import Dropdown from 'bootstrap/js/dist/dropdown';

export class UserProfileNavbarComponent {

    private Logger: Logger = LoggerService.createLogger("UserProfileNavbarComponent");
    private static instance: UserProfileNavbarComponent;

    static get Instance() {

        if (this.instance === null || this.instance === undefined) {
            this.instance = new UserProfileNavbarComponent();
        }
        return this.instance;
    }

    private options: UIUserProfileOptions;

    

    private data2 = {
        isLoading: true,
        isAuthenticated: false,
        isLimited: true,
        direction: 'dropdown',
        email: 'unknown',
        picture: 'https://s.gravatar.com/avatar/072ed4b5a58eb5e5698c964796c8b708?s=480&r=pg&d=https%3A%2F%2Fcdn.auth0.com%2Favatars%2Fab.png',
        subscribeButton: {
            title: "Subscribe",
            url: "https://www.google.com",
        }
    }

    private data: UserProfileNavBar = {
        isLoading: true,
        isAuthenticated: false,
        isLoggedIn: false,
        isLimited: true,
        direction: 'dropdown',
        buttons: {
            subscribe: {
                title: "Subscribe",
                url: "https://www.google.com",
            },
            myaccount: {
                title: "My Account",
                url: "https://www.google.com",
            }
        }

    }

    private proxyData;

    private templateSetup = false;

    constructor() {
        this.Logger.trace("****  CTOR ****");

    }

    setup(opts: UIOptions): void {
        this.Logger.trace("Setting Up User Profile Dropdown Component...");
        this.options = opts.userProfile;
        
        if (OptionsModule.Options.pageSuiteOptions?.enable) {
            if (window['psReader'] && window['psReader']._hasEditionLoaded) {
                this.Logger.trace("Pagesuite is enabled and edition is loaded, setting up template...");
                this.setupTemplate();
            } else {
                this.Logger.trace("Pagesuite is not loaded yet, setting up event listener for onPagesuiteReady...");
                //onPagesuiteReady event is fired when com.pagesuite.editionLaunch is fired. This doesn't happen on the eEdition selection screen.
                EventUtil.listenForEvent(APP_EVENTS.onPagesuiteReady, (event) => {
                    this.Logger.trace("onPagesuiteReady", event);
                    this.setupTemplate();
                });
            }

            EventUtil.listenForEvent(APP_EVENTS.onPagesuiteContentChanged, (event) => {
                this.Logger.trace("onPagesuiteContentChanged", event);
                this.Logger.trace("onPagesuiteContentChanged", "Checking if profile is the last child of the container");
                if (this.removeInjectedProfile()) {
                    this.Logger.trace("onPagesuiteContentChanged", "Profile is not the last child of the container. Setting up template again.");
                    this.setupTemplate();
                }else{
                    this.Logger.trace("onPagesuiteContentChanged", "Profile is the last child of the container. No need to set up template again.");
                }
            });
            
            //If pagesuite is enabled I need to wait for the eEdition Launch event otherwise i'll get an error on the eEdition select page.
        } else {
            this.setupTemplate();
        }

        this.setupEventListeners();
        
        

    }

    

    private readonly profileContainerSelectors = [
        '.reader-features-icon-container-right'        
    ];

    
    private removeInjectedProfile(): boolean {
        const profiles = Array.from(document.querySelectorAll('#mng-user-profile'));
        const containers = this.profileContainerSelectors
            .map((selector) => document.querySelector(selector))
            .filter((container): container is Element => container !== null);
        this.Logger.trace("removeInjectedProfile - profiles found:", profiles);
        this.Logger.trace("removeInjectedProfile - containers found:", containers);

        const isCorrectlyPlaced =
            containers.length > 0 &&
            profiles.length === containers.length &&
            containers.every((container) => container.lastElementChild?.id === 'mng-user-profile') &&
            profiles.every((profile) =>
                containers.some((container) => container.lastElementChild === profile)
            
            );

        if (isCorrectlyPlaced) {
            return false;
        }
        
        profiles.forEach((profile) => profile.remove());
        document.querySelectorAll('#mng-user-profile-navbar').forEach((navbar) => navbar.remove());
        return true;
    }

    private setupTemplate(): void {
        this.Logger.trace("setupTemplate");
        this.Logger.trace("setupTemplate - selector:", this.options.selector);
        const testElement = document.querySelector(this.options.selector);
        this.Logger.trace("setupTemplate - element found?", !!testElement);
        UIUtil.waitForElementToExist(this.options.selector, this.options.selectorWaitOptions.interval, this.options.selectorWaitOptions.maxAttempts,
            () => {
                this.Logger.trace("Auth Status Bar Element Exists => ", this.options.selector);
                const selector = document.querySelector(this.options.selector) as HTMLElement;
                const dropdown = new Dropdown(document.querySelector(this.options.selector));
                
                this.data = { ...this.data, ...this.options };
                this.Logger.trace("Setup Template -> this.data", this.data);
                const dynamicTemplate = new TemplateRenderer(UIModule.HTML.userProfile, this.data, this.options.selector, this.options.insertMethod);
                this.proxyData = dynamicTemplate.bindData();
                this.Logger.trace("proxyData", this.proxyData);
                this.templateSetup = true;
                
            },
            () => {
                this.Logger.warn("Auth Status Bar Element does not exist => ", this.options.selector);
            },
            (attempt) => {
                //this.Logger.trace("Attempt: ", attempt);
            }
        );

    }

    private setupEventListeners(): void {
        this.Logger.trace("setupEventListeners");
        Bus.on(APP_EVENTS.onReady, (data: OnReadyEvent) => {
            this.Logger.trace("onReady Event Received", data);

            // pick the proxy if it exists, otherwise the raw data object
            // this is needed because sometimes this event is fired before the HTML is ready (mainly for Pagesuite)
            const d = this.proxyData ?? this.data;

            //TODO: Need to fix all the question marks, but needed to add this when I added new pipleline steps that happen before auth0 and entitlement, so these are never set.
            const e = Object.assign(d, {
                isLoading: false,
                isAuthenticated: data.auth?.isAuthenticated,
                isLoggedIn: data.auth?.isAuthenticated,
                auth: data.auth,
                //isLimited: !(data.entitlement?.entitlement?.isEntitled ?? false),
                entitlement: data.entitlement?.entitlement
            });
            this.Logger.trace("onReady Event Data After XXX", e);
            if (!this.proxyData) {
                // Template wasn't bound yet when onReady fired (e.g. waitForElementToExist
                // hadn't resolved). Bind it now so this data reaches the DOM.
                this.data = e;
                this.setupTemplate();
            }
        });
         
        //this.setupTemplate();
    }

}